var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Icon_feather-mail",
  "data-name": "Icon feather-mail",
  xmlns: "http://www.w3.org/2000/svg",
  width: 44.199,
  height: 36.24,
  viewBox: "0 0 44.199 36.24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union_35",
  "data-name": "Union 35",
  d: "M6.184,36.24A6.183,6.183,0,0,1,0,30.054V6.31a2.551,2.551,0,0,1,0-.289A6.189,6.189,0,0,1,6.184,0H38.019A6.186,6.186,0,0,1,44.2,6.114v23.94a6.183,6.183,0,0,1-6.18,6.185Zm-1.77-6.185a1.764,1.764,0,0,0,1.77,1.775H38.019a1.767,1.767,0,0,0,1.77-1.775V10.41l-16.432,11.5a2.124,2.124,0,0,1-1.252.408,2.214,2.214,0,0,1-1.274-.408L4.414,10.41ZM22.1,17.417,39.51,5.221a1.769,1.769,0,0,0-1.492-.811H6.184a1.755,1.755,0,0,0-1.492.811Z",
  transform: "translate(0 0)",
  fill: "currentColor"
})));
export { SvgMail as ReactComponent };
export default __webpack_public_path__ + "static/media/mail.ca196d234cda53015ae8001d9886348f.svg";